module.exports = __webpack_public_path__ + "static/media/message-menu.bc56e94a.svg";